import { useQuery } from "@tanstack/react-query";

import { apiRequest } from "../../api/client";
import type { components } from "../../api/generated/schema";
import { ErrorText } from "../catalog/CatalogPages";
import { PlanPreparationPage } from "./PlanPreparationPage";
import { PlansPage } from "./PlansPage";

export type PlanningSummary =
  components["schemas"]["PlanningSummaryResponse"];

export function PlanningPage({
  projectId
}: {
  projectId: string;
}): React.JSX.Element {
  const planning = useQuery({
    queryKey: ["planning", projectId],
    queryFn: () =>
      apiRequest<PlanningSummary>(`/projects/${projectId}/planning`)
  });

  if (planning.isLoading) {
    return (
      <main className="page-shell">
        <p className="state-message">正在读取任课计划编制进度…</p>
      </main>
    );
  }
  if (!planning.data || planning.isError) {
    return (
      <main className="page-shell">
        <a className="back-link" href={`/projects/${projectId}`}>
          ← 返回课表主页
        </a>
        <ErrorText error={planning.error} />
      </main>
    );
  }

  return planning.data.stage === "FOUNDATION" ? (
    <PlanPreparationPage projectId={projectId} summary={planning.data} />
  ) : (
    <PlansPage projectId={projectId} planning={planning.data} />
  );
}
